<app-alert
	[title]="dataVoucher.messageSuccess.message.title"
	[message]="dataVoucher.messageSuccess.message.subTitle"
	[extraContent]="dataVoucher.messageSuccess.extraContent"
	[showCloseButton]="false"
	type="warn"
></app-alert>
